(function () {
	window.addEventListener("DOMContentLoaded", (event) => {
		const anchors = document.querySelectorAll('a[href^="#"]');
		anchors.forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				document.querySelector(this.getAttribute('href')).scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			});
		});
	});

	// function itemDiscount(arr) {
	// 	const parent = document.querySelector('html');
	// 	const currency = parent.dataset.currency;
	// 	const cart = arr.cart.items;
	// 	const discount = arr.discount;

	// 	Array.prototype.forEach.call(cart, (item) => {
	// 		if(item.discounts.length < 1) {
	// 			const price = item.final_price;
	// 			if(discount.discount !== null) {
	// 				const finalDiscount = (parseInt(discount.discount.value, 10) * -1) / 100;
	// 				const finalPrice = ((price / 100) * finalDiscount).toFixed(2);
	// 				const handle = document.querySelector(`.product-${item.handle} .rebuy-cart__flyout-item-price div .rebuy-money`);
	// 				const existHandle = document.querySelector(`.product-${item.handle} .rebuy-cart__flyout-item-price div .rebuy-money.sale`);
					
	// 				if(!existHandle) {
	// 					handle.classList.add('compare-at');
	// 					handle.insertAdjacentHTML("beforebegin", `<span class="rebuy-money sale"><span class="sr-only">Sale price</span> <span>${currency}${finalPrice}</span></span>`);
	// 				}
	// 			}
	// 		}
	// 	});
	// }

	// document.addEventListener('rebuy:smartcart.ready', (event) => {
  //   const arr = event.detail.smartcart;
	// 	const Cart = window.Rebuy.Cart;
	// 	const targetNode = document.querySelector('.rebuy-cart__flyout-discount-container');
	// 	const config = {
	// 		attributes: true, 
	// 		childList: true, 
	// 		characterData: true
	// 	};

	// 	const callback = mutations => {  
	// 		mutations.forEach(mutation => {
	// 			if (mutation.type === 'childList') {
	// 				if (!targetNode.querySelector('.rebuy-cart__flyout-discount-tag')) {
	// 					Array.prototype.forEach.call(Cart.cart.items, (item) => {
	// 						if(item.discounts.length < 1) {
	// 							const compareHandle = document.querySelector(`.product-${item.handle} .rebuy-cart__flyout-item-price div .rebuy-money.compare-at`);
	// 							const existHandle = document.querySelector(`.product-${item.handle} .rebuy-cart__flyout-item-price div .rebuy-money.sale`);
								
	// 							if (existHandle) {
	// 								compareHandle.classList.remove('compare-at')
	// 								existHandle.remove();	
	// 							}
	// 						}
	// 					});
	// 				}

	// 				if (!targetNode.querySelector('form.rebuy-cart__flyout-discount-form')) {
	// 					window.Rebuy.Cart.fetchCart();
	// 				}
	// 			}
	// 		});
	// 	}
		
	// 	const observer = new MutationObserver(callback);

	// 	itemDiscount(arr);
	// 	observer.observe(targetNode, config);
	// });
	

	// document.addEventListener('rebuy:cart.change', (event) => { 
	// 	const parent = document.querySelector('html');
	// 	const currency = parent.dataset.currency;
	// 	const cart = event.detail.cart.cart.items;
	// 	const SmartCart = window.Rebuy.SmartCart;

	// 	if(event.detail) {
	// 		Array.prototype.forEach.call(cart, (item) => {
	// 			if (item.discounts.length < 1) {
	// 				const price = item.final_price;

	// 				if (SmartCart.discount.discount) {
	// 					const finalDiscount = (parseInt(SmartCart.discount.discount.value, 10) * -1) / 100;
	// 					const finalPrice = ((price / 100) * finalDiscount).toFixed(2);
	// 					const handle = document.querySelector(`.product-${item.handle} .rebuy-cart__flyout-item-price div .rebuy-money`);
	// 					const existHandle = document.querySelector(`.product-${item.handle} .rebuy-cart__flyout-item-price div .rebuy-money.sale`);

	// 					if(!existHandle && handle) {						
	// 						if(!isNaN(finalDiscount)) {
	// 							handle.classList.add('compare-at');
	// 							handle.insertAdjacentHTML("beforebegin", `<span class="rebuy-money sale"><span class="sr-only">Sale price</span> <span>${currency}${finalPrice}</span></span>`);
	// 						}
	// 					}
	// 				}
	// 			}
	// 		});
	// 	}
	// });
})();
